import { IAfterGuiAttachedParams } from '@ag-grid-enterprise/all-modules';
import { Component, OnDestroy } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'toggle-renderer',
  template: `
    <mat-slide-toggle (change)="checkedHandler($event)" [checked]="params.value"></mat-slide-toggle>
  `
})
export class ToggleRendererComponent implements ICellRendererAngularComp, OnDestroy {
  params: any;
  checked: boolean;
  ngOnDestroy(): void {}
  refresh(params: any): boolean {
    console.log('refresh');
    if (!params.value || params.value === '0') {
      params.value = false;
    } else if (params.value || params.value === '1') {
      params.value = true;
    }
    this.params = params;
    return true;
  }
  afterGuiAttached?(params?: IAfterGuiAttachedParams): void {}

  agInit(params: any): void {
    if (!params.value || params.value === '0') {
      params.value = false;
    } else if (params.value || params.value === '1') {
      params.value = true;
    }
    this.params = params;
  }

  checkedHandler(event: any) {
    console.log('checked', event);
    const checked = event.checked;
    this.checked = checked;
    const colId = this.params.column.colId;
    console.log('colId', colId);
    this.params.node.setDataValue(colId, checked);
  }

  getValue(): any {
    return this.checked ? 1 : 0;
  }
}
